import { Injectable } from '@angular/core';
import { IStateService } from 'angular-ui-router';
import { includes } from 'lodash';

export interface IStateGoOpts {
  name: string;
  params: object;
}

export interface ICurrentGrouping {
  grouping: {
    columns: object;
    listType: string;
    sections: Array<{}>;
  };
  groupHumanName: string;
}

/* istanbul ignore next */
@Injectable()
export class PrevStateService {
  // class properties
  readonly INVALID_URL_PATH_INCLUSIONS = [
    // appended forward slash to make check more specific, as we now have routes such as ../student-level(JJ)
    '/student/',
    '/profile',
    'supports/new', // prevent ssv from returning to the create new support stepper view
  ];

  constructor() {
    //
  }

  isUrlValid(url: string): boolean {
    const urlIsValid = this.INVALID_URL_PATH_INCLUSIONS.every(urlString => !includes(url, urlString));
    return urlIsValid;
  }

  /**
   * Should be used in current state to get $state options
   * Result should be passed to next state
   * Next state can then use result to go back to previous state (CM)
   */
  getCurrentStateGoOpts(state: IStateService): IStateGoOpts {
    const { current, params } = state;
    const { name } = current;
    const stateGoOpts = {
      name,
      params,
    };

    return stateGoOpts;
  }
}
